import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS as BOOKING_QUERY_KEY } from '../bookings';

import { ENDPOINTS } from '.';

type UpdateReviewParams = {
  reviewId: number;
  bookingCode: string;
};

export function usePublishReview() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ reviewId }: UpdateReviewParams) =>
      apiMutation('POST', {
        path: ENDPOINTS.publishReview,
        params: { reviewId: reviewId.toString() },
      }) as Promise<void>,
    onSuccess: (_, variables) => {
      message.success('Review successfully published');

      queryClient.invalidateQueries({
        queryKey: [BOOKING_QUERY_KEY.booking, { code: variables.bookingCode }],
      });
    },
    onError: () => {
      message.error('Failed to publish review');
    },
  });
}
